import { map, uniq } from "lodash";
import store from "../../root/store/store";
import { Contact } from "../../common/model/crm/contact";
import contactApiService from "../../common/services/contact-api-service";
import { ErrorTemplateBuilder } from "../../infrastructure/error-template-builder";
import { constants } from "../constant/constants";
import { Enums } from "../helper/enums";
import { HttpHelper } from "../helper/http-helper-service";
import { clientLocationEntity } from "../model/entity/client-location-entity";
import { contactEntity } from "../model/entity/contact-entity";
import { contactTagEntity } from "../model/entity/contact-tag-entity";
import { authService } from "./auth-service";

export default class contactService {
  constructor() {}

  static AddContactToStore(contact: Contact) {
    const serviceProviderId =
      store.getters["MasterModule/getServiceProviderId"];
    console.log("MasterModule/getServiceProviderId: " + serviceProviderId);
    if (
      contact != null &&
      (serviceProviderId == null ||
        serviceProviderId == -1 ||
        serviceProviderId == contact.serviceProviderId)
    ) {
      localStorage.setItem("contact", JSON.stringify(contact));
      store.commit("ContactModule/SET_CONTACT", contact);
      return true;
    } else {
      return false;
    }
  }

  static async fetchContactFromApi() {
    const obj = {
      Email: authService.GetAuthenticatedUserEmail(),
    };
    let contact: Contact = await contactApiService.getContactByEmailAddress(
      "",
      obj,
    );
    return contact;
  }

  static async setTheme(params: any) {
    let url: string = constants.apiUrl.crmUrls.getThemeId;
    return HttpHelper.patchData(url, params) as Promise<Contact>;
  }

  static fetchContactFromLocalStorage() {
    let loggedInUserObj: any = null;
    if (localStorage.getItem("contact")) {
      const loggedInUser = localStorage.getItem("contact");
      if (loggedInUser) {
        loggedInUserObj = JSON.parse(loggedInUser);
      }
    }
    return loggedInUserObj;
  }

  static getContactsOfOtherGroups = () => {
    return HttpHelper.getData(
      constants.apiUrl.crmUrls.getContactsOfOtherGroups,
    );
  };

  static getContactsByClientId = (id: number, params: object) => {
    return HttpHelper.getData(
      constants.apiUrl.crmUrls.getContactListByClientId + "/" + id,
      params,
    );
  };

  static getContacts = (param: any = null) => {
    return HttpHelper.getData(constants.apiUrl.crmUrls.getContactList);
  };

  static async getContactByTick(tick: number) {
    return HttpHelper.getData(
      constants.apiUrl.crmUrls.getContactByTick + "?storeTick=" + tick,
    );
  }

  static async setContactTagPermissions() {
    try {
      let loggedInUser: any | null = store.getters["ContactModule/getContact"];
      if (loggedInUser) {
        const globalContactTags = contactTagEntity
          .query()
          .where(
            (contactTag: contactTagEntity) => contactTag.isGlobal,
          )
          .all();
        const globalPortalTagByName = (portalTagName: string) =>
          globalContactTags.find(
            (contactTag: contactTagEntity) =>
              contactTag.name == portalTagName,
          );

        const allTicketsTag = globalPortalTagByName("Portal - All Tickets");

        if (
          loggedInUser.tagIds &&
          allTicketsTag &&
          loggedInUser.tagIds.includes(allTicketsTag.tagId)
        ) {
          store.commit("ContactModule/SET_HasAllTicketsTag", true);
        } else {
          store.commit("ContactModule/SET_HasAllTicketsTag", false);
        }

        const allAssetsTag = globalPortalTagByName("Portal - All Assets");

        if (
          loggedInUser.tagIds &&
          allAssetsTag &&
          loggedInUser.tagIds.includes(allAssetsTag.tagId)
        ) {
          store.commit("ContactModule/SET_HasAllAssetsTag", true);
        } else {
          store.commit("ContactModule/SET_HasAllAssetsTag", false);
        }

        const allInvoicesTag = globalPortalTagByName("Portal - All Invoices");

        if (
          loggedInUser.tagIds &&
          allInvoicesTag &&
          loggedInUser.tagIds.includes(allInvoicesTag?.tagId)
        ) {
          store.commit("ContactModule/SET_HasAllInvoicesTag", true);
        } else {
          store.commit("ContactModule/SET_HasAllInvoicesTag", false);
        }
      }
    } catch (e) {
      console.error(
        ErrorTemplateBuilder.getCatchText(
          "contactService.setContactTagPermissions",
          e,
        ),
      );
    }
  }

  static async setIsBillingContact() {
    try {
      let clientId: number | null = store.getters["ContactModule/getClientId"];
      if (clientId) {
        let allBillingContactIds: any[] = [];
        let clientLocations = await clientLocationEntity
          .query<any>()
          .where("clientId", clientId)
          .all();
        let billingContactsOfClientLocations = map(
          clientLocations,
          "billingContactList",
        );
        for (const billingContacts of billingContactsOfClientLocations) {
          if (billingContacts) {
            allBillingContactIds = allBillingContactIds.concat(billingContacts);
          }
        }
        allBillingContactIds = uniq(allBillingContactIds);
        let allBillingContacts =
          await this.GetAllContactsByContactIdsAndContactStatusId(
            allBillingContactIds,
            Enums.ContactStatus.Active,
          );

        let contactId: number = store.getters["ContactModule/getContactId"];
        if (
          allBillingContacts &&
          allBillingContacts.find((x) => x.contactId == contactId)
        ) {
          store.commit("ContactModule/SET_IsBillingContact", true);
        } else {
          store.commit("ContactModule/SET_IsBillingContact", false);
        }
      }
    } catch (e) {
      console.error(
        ErrorTemplateBuilder.getCatchText(
          "contactService.setIsBillingContact",
          e,
        ),
      );
    }
  }

  static async GetAllContactsByContactIdsAndContactStatusId(
    contactIds: any,
    contactStatusId: number,
  ) {
    return contactEntity
      .query()
      .where("contactId", contactIds)
      .where("contactStatusId", contactStatusId)
      .all();
  }

  static getPratialContactById = (id: number) => {
    return HttpHelper.getData(
      `${constants.apiUrl.crmUrls.getContactList}?ContactIds=${id}`,
    );
  };

  static getContactTagList = () => {
    return HttpHelper.getData(constants.apiUrl.crmUrls.getContactTagList, {});
  };
}
